const customErrors = {
  pt: {
    nifMinLength: 9,
    nifMaxLength: 9,
    nifErrorShort: "O NIF deve ter 9 dígitos.",
    nifErrorNumbersOnly: "O NIF deve conter apenas dígitos.",
    nifErrorInvalid: "O NIF inserido é inválido.",
    nifErrorInvalidCompany: "NIFs empresariais não são aceites.",
    nifErrorInvalidStructure: "NIF inválido, entre em contacto connosco.",
    nifErrorValid: "O NIF inserido é válido.",
    nifErrorRegexInvalid: "Por favor verifique se o NIF está correto.",
    zipCodeErrorRegexInvalid: "Por favor verifique o código de postal.",
    emailErrorInvalid: "Por favor confirme se o email está correto.",
    birthdayMinAge: "Deve ter pelo menos 18 anos de idade.",
  },
  es: {
    nifMinLength: 10,
    nifMaxLength: 12,
    nifErrorShort: "El NIF debe tener 8 dígitos y el indicador de región.",
    nifErrorNumbersOnly:
      "El NIF debe tener solo 8 dígitos y un máximo de 4 caracteres (X12345678A).",
    nifErrorInvalid: "El NIF ingresado no es válido.",
    nifErrorInvalidCompany: "No se aceptan NIF de empresas",
    nifErrorInvalidStructure: "NIF no válido, póngase en contacto con nosotros",
    nifErrorValid: "¡El NIF ingresado es válido!",
    nifErrorRegexInvalid: "Por favor, verifique si el NIF es correcto.",
    zipCodeErrorRegexInvalid: "Por favor, verifique el código postal.",
    emailErrorInvalid:
      "Por favor, confirme si el correo electrónico es correcto.",
    birthdayMinAge: "Debe tener al menos 18 años.",
  },
  fr: {
    nifMinLength: 0,
    nifMaxLength: 0,
    nifErrorShort:
      "Le NIF doit comporter 8 chiffres et l'indicateur de région.",
    nifErrorNumbersOnly:
      "Le NIF doit comporter uniquement 8 chiffres et un maximum de 4 caractères (ESX12345678).",
    nifErrorInvalid: "Le NIF saisi n'est pas valide.",
    nifErrorInvalidCompany: "Les NIF d'entreprise ne sont pas acceptés",
    nifErrorInvalidStructure: "NIF invalide, veuillez nous contacter.",
    nifErrorValid: "Le NIF saisi est valide !",
    nifErrorRegexInvalid: "Veuillez vérifier si le NIF est correct.",
    zipCodeErrorRegexInvalid: "Veuillez vérifier le code postal.",
    emailErrorInvalid: "Veuillez confirmer si l'adresse e-mail est correcte.",
    birthdayMinAge: "Vous devez être âgé d'au moins 18 ans.",
  },
  be: {
    nifMinLength: 0,
    nifMaxLength: 0,
    nifErrorShort:
      "Le NIF doit comporter 8 chiffres et l'indicateur de région.",
    nifErrorNumbersOnly:
      "Le NIF doit comporter uniquement 8 chiffres et un maximum de 4 caractères (ESX12345678).",
    nifErrorInvalid: "Le NIF saisi n'est pas valide.",
    nifErrorInvalidCompany: "Les NIF d'entreprise ne sont pas acceptés",
    nifErrorInvalidStructure: "NIF invalide, veuillez nous contacter.",
    nifErrorValid: "Le NIF saisi est valide !",
    nifErrorRegexInvalid: "Veuillez vérifier si le NIF est correct.",
    zipCodeErrorRegexInvalid: "Veuillez vérifier le code postal.",
    emailErrorInvalid: "Veuillez confirmer si l'adresse e-mail est correcte.",
    birthdayMinAge: "Vous devez être âgé d'au moins 18 ans.",
  },
  nl: {
    nifMinLength: 9,
    nifMaxLength: 9,
    nifErrorShort: "Het NIF moet 9 cijfers bevatten.",
    nifErrorNumbersOnly: "Het NIF mag alleen cijfers bevatten.",
    nifErrorInvalid: "Het ingevoerde NIF is ongeldig.",
    nifErrorInvalidCompany: "Bedrijfs-TIN's worden niet geaccepteerd.",
    nifErrorInvalidStructure: "Ongeldige NIF, neem contact met ons op",
    nifErrorValid: "Het ingevoerde NIF is geldig!",
    nifErrorRegexInvalid: "Controleer of het NIF correct is.",
    zipCodeErrorRegexInvalid: "Controleer de postcode.",
    emailErrorInvalid: "Controleer of het e-mailadres correct is.",
    birthdayMinAge: "Je moet minstens 18 jaar oud zijn.",
  },

  en: {
    nifMinLength: 9,
    nifMaxLength: 9,
    nifErrorShort: "The NIF must have 9 digits.",
    nifErrorNumbersOnly: "The NIF must contain only digits.",
    nifErrorInvalid: "The entered NIF is invalid.",
    nifErrorInvalidCompany: "Corporate NIFs are not accepted.",
    nifErrorInvalidStructure: "Invalid NIF, please contact us.",
    nifErrorValid: "The entered NIF is valid!",
    nifErrorRegexInvalid: "Please check if the NIF is correct.",
    zipCodeErrorRegexInvalid: "Please check the postal code.",
    emailErrorInvalid: "Please confirm if the email address is correct.",
    birthdayMinAge: "You must be at least 18 years old.",
  },
};

let vatNumberEvaluationTreshold = 4;

$(document).ready(function () {
  const lang = getCookieValue("lang");
  const currentLang = lang || "en";

  function validateNIF() {
    debugger;
    const selectedCountry = $("#vatCountry").val();
    if (["PT", "EN", "ES"].includes(selectedCountry)) {
      let valMessage = "";
      let vatNumberLength = vatNumberElement.value.length;
      if (!vatNumberElement) return;
      vatNumberEvaluationTreshold = 8;
      if (vatNumberLength >= vatNumberEvaluationTreshold) {
        if (!selectedCountry) return;
        const nif = vatNumberElement.value.replace(/[\s-]/g, "");
        let messageElement = document.getElementById("vatErrorMessage");
        if (!messageElement) {
          vatNumberElement.classList.add("error");
          messageElement = document.createElement("label");
          messageElement.id = "vatErrorMessage";
          messageElement.classList.add("error");
          vatNumberElement.parentNode.appendChild(messageElement);
        }
        if (selectedCountry === "PT" || selectedCountry === "EN") {
          valMessage = validatePortugueseNIF(nif, messageElement, currentLang);
          return validatePortugueseNIF(nif, messageElement, currentLang);
        } else if (selectedCountry === "ES") {
          return validateSpanishNIF(nif, messageElement, currentLang);
        } else {
          submitbtn.classList.remove("disabled");
          return true;
        }
        return valMessage;
      }
    } else {
      return true;
    }
  }

  function getLanguageCode(isocode) {
    return isocode;
  }
  function changeLanguage(lang, newHostname) {
    document.cookie = `lang=${lang}; path=/; max-age=${30 * 24 * 60 * 60};`;
    const currentUrl = new URL(window.location.href);
    currentUrl.hostname = newHostname;
    window.location.href = newHostname;
  }

  function getCookieValue(cookieName) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === cookieName) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  let vatNumberElement = document.getElementById("vatNumber");

  function cleanVATErrorMessage() {
    $("#vatErrorMessage").remove();
    vatNumberElement.classList.remove("error");
    submitbtn.classList.remove("disabled");
  }

  let submitbtn = document.getElementById("submitbtn");

  function validatePortugueseNIF(nif, messageElement, currentLang) {
    debugger;
    vatNumberEvaluationTreshold = 8;
    if (nif.length >= vatNumberEvaluationTreshold) {
      // Reject specific NIF
      if (nif === "123456789") {
        messageElement.innerHTML =
          customErrors[currentLang].nifErrorInvalidStructure;
        submitbtn.classList.add("disabled");
        return false;
      }

      if (nif.length !== 9) {
        messageElement.innerHTML = customErrors[currentLang].nifErrorShort;
        submitbtn.classList.add("disabled");
        return false;
      }

      if (!/^\d{9}$/.test(nif)) {
        messageElement.innerHTML =
          customErrors[currentLang].nifErrorNumbersOnly;
        submitbtn.classList.add("disabled");
        return false;
      }

      const firstDigit = parseInt(nif[0]);
      // Modified valid first digits to exclude 5, 6, and 9
      const validFirstDigits = [1, 2, 3, 8];
      if (!validFirstDigits.includes(firstDigit)) {
        messageElement.innerHTML =
          customErrors[currentLang].nifErrorInvalidCompany;
        submitbtn.classList.add("disabled");
        return false;
      }

      let sum = 0;
      for (let i = 0; i < 8; i++) {
        sum += parseInt(nif[i]) * (9 - i);
      }

      const checkDigit = 11 - (sum % 11);
      const finalCheckDigit =
        checkDigit === 10 || checkDigit === 11 ? 0 : checkDigit;
      const isValid = finalCheckDigit === parseInt(nif[8]);
      messageElement.innerHTML = isValid
        ? cleanVATErrorMessage()
        : customErrors[currentLang].nifErrorInvalid;
      submitbtn.classList.add("disabled");

      if (isValid) {
        cleanVATErrorMessage();
      }

      return isValid;
    }
  }

  function validateSpanishNIF(nif, messageElement, currentLang) {
    // Individual NIF/NIE validation logic
    const nieRegEx = /^[XYZ]\d{7}[A-Z]$/i; // Foreigners
    const nifRegEx = /^[0-9]{8}[A-Z]$/i; // Spanish citizens
    const companyRegEx = /^[A-HJ-UW][0-9]{7}[A-Z]$/i; // Company NIFs
    const validLetters = "TRWAGMYFPDXBNJZSQVHLCKE";

    // Reject if it's a company NIF
    if (companyRegEx.test(nif.toUpperCase())) {
      messageElement.innerHTML = customErrors[currentLang].nifErrorInvalid;
      submitbtn.classList.add("disabled");
      return false;
    }

    // Convert NIE initial letters to numbers
    let validationNif = nif.toUpperCase();
    if (/^[XYZ]/i.test(validationNif)) {
      validationNif = validationNif
        .replace(/^X/i, "0")
        .replace(/^Y/i, "1")
        .replace(/^Z/i, "2");
    }

    // Check format for individual NIFs/NIEs
    if (
      !nieRegEx.test(nif.toUpperCase()) &&
      !nifRegEx.test(nif.toUpperCase())
    ) {
      messageElement.innerHTML = customErrors[currentLang].nifErrorInvalid;
      submitbtn.classList.add("disabled");
      return false;
    }

    // Get number and letter
    const number = parseInt(validationNif.slice(0, 8), 10);
    const letter = validationNif.slice(-1).toUpperCase();

    // Validate check letter
    const calculatedLetter = validLetters.charAt(number % 23);

    if (letter === calculatedLetter) {
      cleanVATErrorMessage();
      return true;
    } else {
      messageElement.innerHTML = customErrors[currentLang].nifErrorInvalid;
      submitbtn.classList.add("disabled");
      return false;
    }
  }

  if (document.getElementById("contactForm")) {
    $(window).keydown(function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });

    sessionStorage.setItem("customErrors", JSON.stringify(customErrors));
    const savedCustomErrors = JSON.parse(
      sessionStorage.getItem("customErrors")
    );

    const vatCountrySelect = document.getElementById("vatCountry");
    // Get the selected option element
    let selectedOption =
      vatCountrySelect.options[vatCountrySelect.selectedIndex];

    const browserLang = navigator.language || navigator.userLanguage;
    let selectedCountryText = selectedOption.value;

    //form validator
    function validateForm() {
      $("#contactForm").validate({
        errorPlacement: function (error, element) {
          // Find the parent of the element and append the error message to it
          element.closest(".form-input-group").append(error);
        },
        onkeyup: function (element) {
          $(element).valid(); // Validate field on keyup
        },
        onfocusout: function (element) {
          $(element).valid(); // Validate field on focusout
        },
        focusCleanup: true,
        rules: {
          email: {
            required: true,
            email: true,
          },
          confEmail: {
            required: true,
            email: true,
            equalTo: "#email",
          },
          birthday: {
            required: true,
            minAge: 18,
            dateFormat: true,
          },
          postalcode: { required: true, postalcodeLength: true },
        },
        invalidHandler: function (form, validator) {
          submitbtn.classList.add("disabled");
        },
        messages: {
          confEmail: {
            equalTo: customErrors[lang].emailErrorInvalid,
          },
          birthday: {
            required: "Please enter your birth date",
            dateFormat: "Please enter a valid date (DD/MM/YYYY)",
          },
        },
      });
    }

    validateForm();
    validateNIF();

    $(".postalcode-dash").on("input", function (e) {
      const selectedCountry = $("#vatCountry").val();
      let value = $(this)
        .val()
        .replace(/[^\d-]/g, "");
      switch (selectedCountry) {
        case "PT":
        case "EN":
          // Portuguese format: 0000-000
          value = value.replace(/-/g, "");
          if (value.length > 4) {
            value = value.substring(0, 4) + "-" + value.substring(4);
          }
          value = value.substring(0, 8);
          break;

        case "ES":
          // Spanish format: 00000
          value = value.replace(/-/g, "");
          value = value.substring(0, 5);
          break;

        case "FR":
        case "BE":
          // French/Belgian format: 00000
          value = value.replace(/-/g, "");
          value = value.substring(0, 5);
          break;

        default:
          // Default behavior - just limit to reasonable length
          value = value.substring(0, 10);
      }

      $(this).val(value);
    });

    $.validator.addMethod(
      "postalcodeLength",
      function (value, element) {
        const selectedCountry = $("#vatCountry").val();
        const countryData = $("#vatCountry option:selected").data();
        const postalRegex = countryData.postalpattern;

        const cleanValue = value.replace(/[^\d]/g, "");

        if (!postalRegex) return true;

        const regex = new RegExp(postalRegex);
        return regex.test(value);
      },
      function (params, element) {
        return customErrors[lang].zipCodeErrorRegexInvalid;
      }
    );

    $.validator.addMethod(
      "minAge",
      function (value, element, minAge) {
        if (!value) return false;

        const parts = value.split("/");
        if (parts.length !== 3) return false;

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are 0-based
        const year = parseInt(parts[2], 10);

        const birthDate = new Date(year, month, day);
        const today = new Date();

        if (isNaN(birthDate.getTime())) return false;

        let age = today.getFullYear() - birthDate.getFullYear();

        if (
          today.getMonth() < birthDate.getMonth() ||
          (today.getMonth() === birthDate.getMonth() &&
            today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        // console.log('Calculated age:', age);
        return age >= minAge;
      },
      function (params, element) {
        return customErrors[lang].birthdayMinAge;
      }
    );

    $.validator.addMethod(
      "dateFormat",
      function (value, element) {
        if (!value) return true;

        if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) return false;

        const parts = value.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        if (year < 1900 || year > new Date().getFullYear()) return false;
        if (month < 1 || month > 12) return false;

        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) return false;

        return true;
      },
      "Please enter a valid date in DD/MM/YYYY format"
    );

    $("#vatCountry").on("change", function () {
      let selectedCountry = this.value;

      let vatGroupField = document.getElementById("VatNumberGroup");
      let vatNumberField = document.getElementById("vatNumber");
      let formCompanyGroup = document.getElementById("formCompanyGroup");

      // Check if the selected country is PT or ES
      if (
        selectedCountry === "PT" ||
        selectedCountry === "ES" ||
        selectedCountry === "EN"
      ) {
        vatGroupField.classList.remove("uk-hidden");
        vatNumberField.setAttribute("required", "required");
        formCompanyGroup.classList.remove("uk-width-1-1@m");
        formCompanyGroup.classList.add("uk-width-1-2@m");

        if ($("#contactForm").data("validator")) {
          vatNumberField.classList.remove("disabled");
          validateNIF();
        }
      } else {
        vatGroupField.classList.add("uk-hidden");
        vatNumberField.removeAttribute("required");
        formCompanyGroup.classList.remove("uk-width-1-2@m");
        formCompanyGroup.classList.add("uk-width-1-1@m");

        cleanVATErrorMessage();
        vatNumberField.classList.add("disabled");
        vatNumberField.value = "";
      }

      document.getElementById("postalcode").placeholder = $(this)
        .children("option:selected")
        .data("postalplaceholder");

      const postalCodeField = $("#postalcode");
      postalCodeField.val("");

      if ($("#contactForm").data("validator")) {
        postalCodeField.valid();
      }

      validateForm();
    });
    $("#contactForm").on("submit", function (e) {
      validateForm();
      validateNIF();

      // selectedCountryText = $("#vatCountry").val();
      // console.log("lang do browser: ", browserLang);
      // console.log("lang escolhida: ", getLanguageCode(lang));
      // console.log("país escolhido no form:", selectedCountryText);

      if ($("#contactForm").valid()) {
        const selectedCountry = $("#vatCountry").val();
        const requiresVAT = ["PT", "ES", "EN"].includes(selectedCountry);

        // Only check VAT validation if country requires it
        if (requiresVAT) {
          if (validateNIF() === true) {
            // Form is valid and VAT is valid
            e.preventDefault();
            $("#contactForm #submitbtn").css("display", "none");
            $("#contactForm").addClass("disabled");
            if (document.getElementById("contactFormSpinner") != null) {
              $("#contactForm #contactFormSpinner").css("display", "block");
            } else {
              //Appending spinner
              $("#contactForm #submitbtn").after(
                `<div id="contactFormSpinner" uk-spinner class="uk-button uk-border-rounded uk-margin-top uk-button-rounded uk-button-fixed-width uk-margin-auto uk-box-shadow-small uk-padding-small"></div>`
              );
            }
            var url = "app/api/v1/card_subscription.php";
            // POST values in the background the the script URL
            $.ajax({
              type: "POST",
              url: url,
              data: $(this).serialize(),
              success: function (data) {
                // data = JSON object that contact.php returns
                // we recieve the type of the message: success x danger and apply it to the
                var messageAlert = "alert-" + data.type;
                var messageText = data.message;
                // let's compose Bootstrap alert box HTML
                var alertBox =
                  '<div uk-alert class="uk-' +
                  messageAlert +
                  ' uk-text-center"  ><a href class="uk-alert-close" uk-close></a>' +
                  messageText +
                  "</div>";
                // If we have messageAlert and messageText
                if (messageAlert && messageText) {
                  //TODO anchor up?
                  // inject the alert to .messages div in our form
                  $("#contactFormMessages").html(alertBox);
                  $("#contactForm").removeClass("disabled");

                  $(".uk-input.valid, .uk-textarea.valid").removeClass("valid");
                  $("#contactForm #submitbtn").css("display", "block");
                  $("#contactForm #contactFormSpinner").css("display", "none");

                  if (data.success) {
                    // empty the form
                    $("#contactForm")[0].reset();
                    $("#contactForm").removeClass("disabled");

                    // Keep the form form but hide the button
                    $("#submitbtn").hide();
                  }
                }
              },
            });
          }
        } else {
          // Form is valid and no VAT validation needed
          e.preventDefault();
          $("#contactForm #submitbtn").css("display", "none");
          $("#contactForm").addClass("disabled");
          if (document.getElementById("contactFormSpinner") != null) {
            $("#contactForm #contactFormSpinner").css("display", "block");
          } else {
            //Appending spinner
            $("#contactForm #submitbtn").after(
              `<div id="contactFormSpinner" uk-spinner class="uk-button uk-border-rounded uk-margin-top uk-button-rounded uk-button-fixed-width uk-margin-auto uk-box-shadow-small uk-padding-small"></div>`
            );
          }
          var url = "app/api/v1/card_subscription.php";
          // POST values in the background the the script URL
          $.ajax({
            type: "POST",
            url: url,
            data: $(this).serialize(),
            success: function (data) {
              // data = JSON object that contact.php returns
              // we recieve the type of the message: success x danger and apply it to the
              var messageAlert = "alert-" + data.type;
              var messageText = data.message;
              // let's compose Bootstrap alert box HTML
              var alertBox =
                '<div uk-alert class="uk-' +
                messageAlert +
                ' uk-text-center"  ><a href class="uk-alert-close" uk-close></a>' +
                messageText +
                "</div>";
              // If we have messageAlert and messageText
              if (messageAlert && messageText) {
                //TODO anchor up?
                // inject the alert to .messages div in our form
                $("#contactFormMessages").html(alertBox);
                $("#contactForm").removeClass("disabled");

                $(".uk-input.valid, .uk-textarea.valid").removeClass("valid");
                $("#contactForm #submitbtn").css("display", "block");
                $("#contactForm #contactFormSpinner").css("display", "none");

                if (data.success) {
                  // empty the form
                  $("#contactForm")[0].reset();
                  $("#contactForm").removeClass("disabled");

                  // Keep the form form but hide the button
                  $("#submitbtn").hide();
                }
              }
            },
          });
        }
      } else {
        console.log("form valido: ", $("#contactForm").valid());

        console.log("nif valido: ", validateNIF() == true);
        submitbtn.classList.add("disabled");
        validateForm();
        validateNIF();
        $("#contactForm :input").on("input change", function () {
          submitbtn.classList.remove("disabled");

          const inputElement = $(this);
          const inputValue = inputElement.val();
          const inputName = inputElement.attr("name");

          //console.log(`Input ${inputName} changed to: ${inputValue}`);

          // Trigger validation on the changed field
          if ($("#contactForm").data("validator")) {
            inputElement.valid();
          }

          if (inputName === "vatNumber") {
            debugger;
            validateNIF();
          }
        });
      }
      return false;
    });

    formIndex = 0;
    formTabsLength = $(".form-tab").length - 1;

    $("#birthday").on("focus", function () {
      $("#birthday").removeClass("date-placeholder");
    });

    //format postal code
    let postalCode = $(".postalcode-dash");
    console.log();

    if (document.getElementById("vatCountry")) {
      document
        .getElementById("vatCountry")
        .addEventListener("change", function () {
          let selectedCountry = this.value;

          if (selectedCountry == "PT" || selectedCountry == "EN") {
            postalCode.bind("keyup", function (ev) {
              if (ev.which !== 7) {
                let input = postalCode.val();
                let out = input.replace(/\D/g, "");
                let len = out.length;
                if (len > 1 && len < 4) {
                  out = out.substring(0, 4);
                } else if (len > 4) {
                  out = out.substring(0, 4) + "-" + out.substring(4, 7);
                  out = out.substring(0, 10);
                }

                postalCode.val(out);
              }
            });
          } else {
            postalCode.unbind("keyup");
          }

          let vatGroupField = document.getElementById("VatNumberGroup");
          let vatNumberField = document.getElementById("vatNumber");
          let formCompanyGroup = document.getElementById("formCompanyGroup");

          if (selectedCountry === "PT" || selectedCountry === "ES") {
            vatGroupField.classList.remove("uk-hidden");
            vatNumberField.setAttribute("required", "required");
            formCompanyGroup.classList.remove("uk-width-1-1@m");
            formCompanyGroup.classList.add("uk-width-1-2@m");
          } else {
            vatGroupField.classList.add("uk-hidden");
            vatNumberField.removeAttribute("required");
            formCompanyGroup.classList.remove("uk-width-1-2@m");
            formCompanyGroup.classList.add("uk-width-1-1@m");
          }
        });
    }

    const today = new Date();
    const endDate = new Date(today.setFullYear(today.getFullYear() - 18));

    // Initialize the datepicker
    $("#birthday").datepicker({
      dateFormat: "dd/mm/yy",
      changeMonth: true,
      changeYear: true,
      yearRange: "-100:+0",
      maxDate: new Date(
        new Date().getFullYear() - 18,
        new Date().getMonth(),
        new Date().getDate()
      ),
      beforeShow: function (input, inst) {
        const minYear = new Date().getFullYear() - 100;
        const maxYear = new Date().getFullYear() - 18;
        inst.settings.yearRange = minYear + ":" + maxYear;
      },
      onSelect: function (dateText, inst) {
        $(this).valid();
      },
    });

    $("#birthday").on("input", function (e) {
      let value = $(this).val().replace(/\D/g, "");

      if (value.length >= 2) {
        value = value.substring(0, 2) + "/" + value.substring(2);
      }
      if (value.length >= 5) {
        value = value.substring(0, 5) + "/" + value.substring(5);
      }
      if (value.length > 10) {
        value = value.substring(0, 10);
      }

      $(this).val(value);
    });
  }

  $("#advantagesAccordion li").each(function () {
    var advantageImageID = this.dataset.advantage;
    $("#advantageImageContainer").prepend(
      "<div  uk-img='loading: eager' class='advantage-bgimage advantage-number-" +
        advantageImageID +
        "' ></div>"
    );
  });

  function setInitialImage() {
    initialAdvantageAccordionElement = $("#advantagesAccordion")
      .children(".uk-open")
      .data("advantage");
    initialAdvantageImage =
      "advantage-number-" + initialAdvantageAccordionElement;
    $("." + initialAdvantageImage).addClass("visible");
  }
  setInitialImage();
  UIkit.util.on("#advantagesAccordion", "shown", function () {
    let currentAdvantageAccordionElement = $("#advantagesAccordion")
      .children(".uk-open")
      .data("advantage");
    currentAdvantageImage =
      "advantage-number-" + currentAdvantageAccordionElement;
    $(".advantage-bgimage.visible").removeClass("visible");
    $("." + currentAdvantageImage).addClass("visible");
  });
  const gradientElement = $(".mouse-gradient");
  gradientElement.on("mousemove", function (e) {
    gradientElement.css(
      "background-image",
      "radial-gradient(at " +
        e.clientX +
        "px " +
        e.clientY +
        "px, rgba(212, 212, 212) 0, #f1f1f1 70%)"
    );
  });

  let socialDefault = "pt";
  socialGridContainer = $("#socialContainer");

  function fetchSocials(language) {
    const defaultLang = "en";
    const validLang = language || defaultLang;
    const socialGridContainer = $("#socialContainer");

    if (!socialGridContainer.length) return;

    const socialAPI = `https://api.iservices.pt/api/v1/social?lang=${validLang}`;

    fetch(socialAPI)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.data && data.data.social) {
          socialGridContainer.empty();
          Object.entries(data.data.social).forEach(([id, item]) => {
            if (item && item.url && item.image) {
              socialGridContainer.append(`
                <div class="uk-padding-xsmall uk-padding-remove-bottom social-icon">
                  <a href="${item.url}" 
                     title="${item.title || "Social Media"}" 
                     target="_blank" 
                     rel="noopener noreferrer">${item.image}</a>
                </div>
              `);
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching social media:", error);
      });
  }

  document.querySelectorAll(".changeLanguage").forEach((element) => {
    element.addEventListener("click", () => {
      changeLanguage(
        element.getAttribute("data-isocodeAlias"),
        element.getAttribute("data-url")
      );
    });
  });

  fetchSocials(lang);

  if (document.getElementById("vatNumber")) {
    $("#vatNumber").on("input", validateNIF);
    $("#vatCountry").on("change", validateNIF);
  }

  const parallaxSection = document.getElementById("appMobileParallax");
  const parallaxImage = document.getElementById("parallaxAppImage");

  function updateParallax() {
    const sectionTop = parallaxSection.getBoundingClientRect().top;
    const sectionHeight = parallaxSection.offsetHeight;
    const imageHeight = parallaxImage.offsetHeight;

    let scrollProgress =
      1 - (sectionTop + sectionHeight) / (sectionHeight + window.innerHeight);

   



    scrollProgress = Math.max(0, Math.min(1, scrollProgress));
    const translateY = scrollProgress * (sectionHeight + imageHeight) - window.innerHeight / 5;
    
    parallaxImage.style.transform = `translateX(-50%) translateY(-${translateY}px)`;
  }

  updateParallax();

  window.addEventListener("scroll", updateParallax);
  window.addEventListener("resize", updateParallax);

  $("#slideshow > div:gt(0)").hide();

setInterval(function() {
  $('#slideshow > div:first')
    .fadeOut(1000)
    .next()
    .fadeIn(1000)
    .end()
    .appendTo('#slideshow');
}, 3000);
});



        // const sliderElement = document.querySelector('#home-slider-advantages');


        document.addEventListener('DOMContentLoaded', function() {
          UIkit.slider('#home-slider-advantages', {
              autoplay: true,
              autoplayInterval: 2500,
              draggable: false
          });
          if ($('#home-slider-advantages')) {
            $('#home-slider-advantages').on('click', function (event) {
                  event.preventDefault(); // Prevent any default action that might cause scrolling
              });

            $('#home-slider-advantages').on('beforeitemshow', function (event) {
                  //event.preventDefault(); // Prevent any default action that might cause scrolling
              });
          }

          
      });

          const slideItems = document.querySelectorAll('.advantage-slide-wrapper');

          function adjustSlideWidth() {

              if (window.innerWidth > 960) {
                  const parentUl = document.querySelector('.uk-slider-items');
                  const availableWidth = parentUl.clientWidth;
                  const slideWidth = (availableWidth / 2) - 35; // subtract 0% of the grid gap and show only two slides at once

                  slideItems.forEach(item => {
                      item.style.width = `${slideWidth}px`;
                  });
              } else {
                  slideItems.forEach(item => {
                      item.style.width = ''; // Reset width for smaller screens
                  });
              }
          }

          // Adjust slide width on load and on window resize
          adjustSlideWidth();
          window.addEventListener('resize', adjustSlideWidth);
